module.exports = __webpack_public_path__ + "static/media/hsing_chen_liu.2e8d52b7.jpg";